import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { SignalRService } from './signalr.service';
import { PlatformService } from '../platform/platform.service';
import { CustomLoaderService } from 'src/app/shared/custom-loader/custom-loader.service';

export interface SignalrApi {
    doConnectHub(hubUrl: string): void;
    doAuthenticateHub(userId: string, societeId: string): void;
    doUnauthenticateHub(): void;
    isConnected(): boolean;
}

@Injectable({
    providedIn: 'root'
})
export class SignalRAndroidService extends SignalRService {
    constructor(
        protected _apiService: ApiService,
        protected _platformService: PlatformService,
        protected _customLoaderService: CustomLoaderService,
    ) {
        super(_apiService, _platformService, _customLoaderService);

        window['SignalrApi'].emitEvent = (_event: string, _datas: any) => {
            this.eventListener$.next({ event: _event, datas: _datas });
        };

        window['SignalrApi'].showLoader = (message: string, showProgress?: boolean, timeout?: number) => {
            this._customLoaderService.show(message, showProgress);
            if (timeout !== undefined) {
                setTimeout(() => this._customLoaderService.hide(), timeout);
            }
        };

        window['SignalrApi'].hideLoader = () => {
            this._customLoaderService.hide();
        };
    }

    doConnectHub(): Promise<void> {
        return new Promise((resolve, reject) => {
            const signalrApi: SignalrApi = window['SignalrApi']; 
            signalrApi.doConnectHub(this._apiService.coreEndpointUrl);
            resolve();
        });
    }

    disconnect(): void {
        throw new Error("Method not implemented.");
    }

    isConnected(): boolean {
        const signalrApi: SignalrApi = window['SignalrApi']; 
        const isConnected = signalrApi.isConnected()
        return isConnected;
    }

    authenticate(userId: string, societeId: string): void {
        const signalrApi: SignalrApi = window['SignalrApi']; 
        signalrApi.doAuthenticateHub(userId, societeId);
    }
    
    unauthenticate(): void {
        const signalrApi: SignalrApi = window['SignalrApi']; 
        signalrApi.doUnauthenticateHub();
    }
}